import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const capabilities = ['Block distracting apps during focus time', 'Set daily limits on social media', 'Schedule recurring sessions (work, sleep, meals)', 'Track your balance without judgment', 'Take mindful breaks with breathing prompts', 'See weekly patterns in your digital life'];
export function CapabilitiesSection() {
  return <section className="py-24 px-6 bg-pond-dark relative" data-id="element-12">
      <div className="max-w-6xl mx-auto" data-id="element-13">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-14">
          {/* Left - Visual */}
          <motion.div className="flex-1 w-full" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-15">
            <h2 className="text-4xl md:text-5xl font-serif text-pond-cream mb-6" data-id="element-16">
              What You Can Do
            </h2>
            <p className="text-lg text-pond-cream-muted font-light mb-10" data-id="element-17">
              Simple, powerful tools designed to help you build a healthier
              relationship with your device.
            </p>

            {/* App Preview Card */}
            <div className="relative bg-pond-dark-card rounded-3xl p-6 border border-pond-blue/10" data-id="element-18">
              <div className="flex items-center gap-4 mb-6" data-id="element-19">
                <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-pond-blue to-pond-lavender flex items-center justify-center" data-id="element-20">
                  <span className="text-2xl" data-id="element-21">🪷</span>
                </div>
                <div data-id="element-22">
                  <p className="text-pond-cream font-medium" data-id="element-23">Focus Session</p>
                  <p className="text-pond-cream-muted text-sm" data-id="element-24">
                    Deep Work • 2 hours
                  </p>
                </div>
              </div>

              {/* Blocked Apps */}
              <div className="space-y-3" data-id="element-25">
                <p className="text-pond-cream-muted text-xs uppercase tracking-wider" data-id="element-26">
                  Blocked during session
                </p>
                <div className="flex gap-2" data-id="element-27">
                  {['📱', '📸', '🐦', '📺', '💬'].map((emoji, i) => <div key={i} className="w-10 h-10 rounded-xl bg-pond-dark flex items-center justify-center opacity-50" data-id="element-28">
                      <span data-id="element-29">{emoji}</span>
                    </div>)}
                </div>
              </div>

              {/* Progress */}
              <div className="mt-6 pt-6 border-t border-pond-blue/10" data-id="element-30">
                <div className="flex justify-between text-sm mb-2" data-id="element-31">
                  <span className="text-pond-cream-muted" data-id="element-32">Progress</span>
                  <span className="text-pond-blue" data-id="element-33">1h 23m remaining</span>
                </div>
                <div className="h-2 bg-pond-dark rounded-full overflow-hidden" data-id="element-34">
                  <motion.div className="h-full bg-gradient-to-r from-pond-blue to-pond-lavender rounded-full" initial={{
                  width: 0
                }} whileInView={{
                  width: '38%'
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 1,
                  delay: 0.5
                }} data-id="element-35" />
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right - List */}
          <motion.div className="flex-1 w-full" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-36">
            <ul className="space-y-4" data-id="element-37">
              {capabilities.map((item, index) => <motion.li key={index} className="flex items-center gap-4 p-5 rounded-2xl bg-pond-dark-card/50 border border-transparent hover:border-pond-blue/20 transition-colors" initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1 * index,
              duration: 0.5
            }} data-id="element-38">
                  <div className="w-8 h-8 rounded-full bg-pond-blue/20 flex items-center justify-center flex-shrink-0" data-id="element-39">
                    <Check size={16} className="text-pond-blue" data-id="element-40" />
                  </div>
                  <span className="text-lg text-pond-cream font-light" data-id="element-41">
                    {item}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}